// @flow
import type { FetchFrontendConfigurationResponse } from '../types';

export default (opts: Object = {}): FetchFrontendConfigurationResponse => ({
  flags: {},
  settings: {
    branchKey: '',
    ccTld: '',
    countryCode: '',
    csrfCookieName: '',
    dogSizeBuckets: {
      small: '',
      medium: '',
      large: '',
      giant: '',
    },
    googleMapsClientId: '',
    gtmContainerId: '',
    imageUploadMaxSize: 0,
    isBeforeHoliday: false,
    language: '',
    personReferralCampaign: '',
    staticSvgPresent: '',
    supportsMobileApp: false,
    supportsReferral: false,
    weightUnit: '',
    roverNowEnabled: false,
    groomingEnabled: false,
  },
  ...opts,
});



// WEBPACK FOOTER //
// ../react-lib/src/factories/fetchFrontendConfigurationResponseFactory.js